<template>
  <div :class="$style.step">
    <header>
      <i :class="`iconfont yw-xiangzuo ${$style.back}`" @click="back"></i>
      <p>提现攻略</p>
    </header>
    <div :class="$style.operation">
      <div>
        <h3>支付宝提现</h3>
        <p>选择支付宝提现，根据提示进行提现认证，通过支付宝授权的方式绑定支付宝账号，发起提现申请，我们将通过支付宝转账将提现金额发放给玩家。</p>
        <p>注：<span style="color: #e85333;">一个支付宝账号只能关联一个游戏账号。</span></p>
      </div>
      <div>
        <h3>微信提现</h3>
        <p>选择微信提现，根据提示，复制绑定码并在链接引导下关注微信公众号，在公众号的【福利中心】-【红包提现】中输入绑定码完成账号绑定。发起提现申请，我们将通过微信红包将提现金额发放给玩家。</p>
      </div>
      <div>
        <h3>游戏直充</h3>
        <p>提现金额会转化为游戏内真实充值，获取游戏货币；您可在提现记录中查询提现进度。</p>
      </div>
      <p :class="$style.hint">注：<span>请勿取关公众号</span>，取关将无法正常领取红包；微信红包有<span>24小时</span>有效期，请在成功提现之后尽快领取。</p>
    </div>
    <button :class="$style.copy" @click="jump">前往微信</button>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { mapState } from 'vuex';
import { gameOpenDownloads } from '@/bridge/AppJsBridge';

export default {
  name: '',
  data() {
    return {
      wechat: 'btmao888',
    };
  },
  mounted() {
    this.copyInit();
  },
  computed: {
    ...mapState({
      receive_info: (state) => state.redEnvelope.receive_info,
    }),
  },
  methods: {
    back() {
      this.$emit('backWallet');
    },
    copyInit() {
      this.copy = new Clipboard('.copy-btn');
      this.copy.on('success', (e) => {
        this.$toast('复制成功');
      });
    },
    jump() {
      gameOpenDownloads({
        gameUrl: this.receive_info.jump_link,
      });
    },
  },
};
</script>

<style lang="scss" module>
$font-lg: 15px;
$font-nm: 13px;
$font-sm: 11px;

.resetBtn {
  background-color: transparent;
  border: none;
  outline: none;
}
.btnActive {
  &:active {
    -webkit-filter: brightness(110%);
    filter: brightness(110%);
  }
}

.special {
  color: #ff8b23;
}
.step {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: #ffffff;
  overflow: auto;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    display: none;
  }
  > header {
    position: relative;
    font-size: $font-lg;
    padding: 12px 0 24px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 21px;
    background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/red-envelope/v2/condition_back.png');
    background-size: 100% 100%;
    > .back {
      position: absolute;
      left: 0;
      font-size: $font-lg;
      box-sizing: content-box;
      padding: 5px {
        top: 0;
        left: 0;
      }
    }
  }
  .operation {
    font-size: 0;
    color: #424242;
    margin-bottom: 10px;
    padding: 0 10px;
    > div {
      margin-bottom: 20px;
      > h3 {
        font-size: $font-nm;
        margin-bottom: 11px;
      }
      > p {
        font-size: $font-sm;
        line-height: 15px;
      }
    }
    .hint {
      font-size: $font-sm;
      > span {
        color: #e85333;
      }
    }
  }
  .methods {
    padding: 0 10px;
    > h3 {
      font-size: $font-nm;
      margin-bottom: 11px;
    }
    > p {
      font-size: $font-sm;
      line-height: 15px;
    }
  }
  .qrcode {
    display: block;
    margin: auto;
    width: 109px;
    height: 109px;
    margin-top: 20px;
  }
  .copy {
    @extend .resetBtn;
    @extend .btnActive;
    display: block;
    margin: auto;
    width: 140px;
    height: 33.5px;
    border-radius: 33.5px;
    background: #ff5b58;
    color: #ffffff;
    font-size: $font-sm;
    margin-top: 20px;
  }
  .officialTips {
    font-size: $font-sm;
    line-height: 15px;
    margin: 20px 10px;
    > span {
      color: #ff8b23;
    }
  }
}
</style>